// @ts-nocheck
/* eslint-disable */
export const appAssetOverviewCircleIcon = {
    data: `<svg viewBox="0 0 114 87" fill="none" xmlns="http://www.w3.org/2000/svg"><ellipse cx="57" cy="43.0408" rx="57" ry="43.0408" fill="currentColor"/></svg>`,
    name: 'asset-overview-circle' as const
};